import React from 'react'

export default function Layout({ children }: any): JSX.Element {
    return (
        <>
            {children}
        </>
    )
}
